<t4-header icon="glyphicon-stats">
  <button mat-button color="primary" (click)="save()" [disabled]="!isValid()"><mat-icon>save</mat-icon>Save</button>
</t4-header>
<t4-container title="">
  <div class="col-sm-4 col-xs-12">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'T4.Settings.Pricelist.txtName' | translate : 'Name' }}</mat-label>
      <input matInput type="text" required [(ngModel)]="pricelist.Title" #txtTitle="ngModel" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'T4.Settings.Pricelist.drpType' | translate : 'Type' }}</mat-label>
      <mat-select [(ngModel)]="pricelist.Type" [disabled]="true">
        <mat-option [value]="0">{{ 'T4.Settings.Pricelist.optTypeRent' | translate : 'Rent' }}</mat-option>
        <mat-option [value]="2">{{ 'T4.Settings.Pricelist.optTypeAddons' | translate : 'Addons' }}</mat-option>
        <mat-option [value]="1">{{ 'T4.Settings.Pricelist.optTypeSpareParts' | translate : 'Spare parts' }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-sm-4 col-xs-12">
    <mat-slide-toggle [(ngModel)]="pricelist.IsActive">Active</mat-slide-toggle>
    <div *ngIf="!pricelist.IsActive">{{ 'T4.Settings.Pricelist.msgNotActive' | translate : 'This pricelist is not active and will not be used for calculations until activated.' }}</div>
  </div>
  <div class="col-sm-4 col-xs-12">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'T4.Settings.Pricelist.txtValidFrom' | translate : 'Valid from' }}</mat-label>
      <input matInput type="text" [matDatepicker]="picker" required [(ngModel)]="pricelist.ValidFrom" #txtValidFrom="ngModel"/>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'T4.Settings.Pricelist.txtValdThrough' | translate : 'Vallid through' }}</mat-label>
      <input matInput type="text" [matDatepicker]="picker2"  [(ngModel)]="pricelist.ValidThrough"/>
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
  </div>
</t4-container>
<t4-container title="{{ 'T4.Settings.Pricelist.lblSettings' | translate : 'Settings' }}" *ngIf="pricelist.Type != 1">
  <mat-tab-group>
    <mat-tab label="Avgifter">
      <div class="col-sm-4 col-xs-12">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'T4.Settings.Pricelist.txtOnlineFee' | translate : 'Online booking fee' }}</mat-label>
          <input matInput type="text" [(ngModel)]="pricelist.OnlineBookingFee" (keypress)="numberOnly($event)" />
          <mat-icon matSuffix matTooltip="{{ 'T4.Settings.Pricelist.tipOnlineFee' | translate : 'A booking fee added for online reservations' }}">help</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'T4.Settings.Pricelist.txtOfflineFee' | translate : 'In store booking fee' }}</mat-label>
          <input matInput type="text" [(ngModel)]="pricelist.OfflineBookingFee" (keypress)="numberOnly($event)" />
          <mat-icon matSuffix matTooltip="{{ 'T4.Settings.Pricelist.tipOfflineFee' | translate : 'A booking fee added to in store reservations' }}">help</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'T4.Settings.Pricelist.txtInPlaceBookingFee' | translate : 'In place booking fee' }}</mat-label>
          <input matInput type="text" [(ngModel)]="pricelist.InPlaceBookingFee" (keypress)="numberOnly($event)" />
          <mat-icon matSuffix matTooltip="{{ 'T4.Settings.Pricelist.tipInPlaceBookingFee ' | translate : 'A booking fee that supersedes the default fee when doing a in place reservation close to pickup time.' }}">help</mat-icon>
        </mat-form-field>

      </div>
    </mat-tab>
    <mat-tab label="Gratisperiod">
      <div class="col-sm-4 col-xs-12">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'T4.Settings.Pricelist.txtFreeDays' | translate : 'Number of rent free days' }}</mat-label>
        <input matInput type="text"  [(ngModel)]="pricelist.FreeRentalDays" (keypress)="numberOnly($event)" />
        <mat-icon matSuffix matTooltip="{{ 'T4.Settings.Pricelist.tipFreeDays' | translate : 'The number of days that will be free. A value of 1 means that it is free until midnight, regardless of start time. 2 is next midnight etc.' }}">help</mat-icon>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'T4.Settings.Pricelist.txtFreeHours' | translate : 'Number of free hours' }}</mat-label>
        <input matInput type="text" [(ngModel)]="pricelist.FreeRentalHours" (keypress)="numberOnly($event)" />
        <mat-icon matSuffix matTooltip="{{ 'T4.Settings.Pricelist.tipFreeHours' | translate : 'The number of hours that will be rent free. If used in conjunction with days the hours will be added to them.' }}">help</mat-icon>
      </mat-form-field>
        </div>
    </mat-tab>
    <mat-tab label="Försening">
      <div class="col-sm-4 col-xs-12">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'T4.Settings.Pricelist.txtAcceptedDelay' | translate : 'Accepted delay in minutes' }}</mat-label>
          <input matInput type="text" [(ngModel)]="pricelist.AcceptedOverdueInMinutes" (keypress)="numberOnly($event)" />
          <mat-icon matSuffix matTooltip="{{ 'T4.Settings.Pricelist.tipAcceptedOverdue' | translate : 'The time in minutes before delay penalty kicks in' }}">help</mat-icon>
        </mat-form-field>
      </div>
      <div class="col-sm-4 col-xs-12">
        <mat-slide-toggle [(ngModel)]="pricelist.IgnoreExcessRent">{{ 'T4.Settings.Pricelist.chkIgnoreExcessRent' | translate : 'Ignore delay rent' }}</mat-slide-toggle>
        <div>{{ 'T4.Settings.Pricelist.tipIgnoreExcessRent' | translate : 'When this is checked, the original cost of the extended rental will be ignored and only the penalty fee is paid. Otherwise both rent and the penalty fee will be charged.' }}</div>
      </div>  
      <div class="col-sm-4 col-xs-12">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'T4.Settings.Pricelist.txtOneTimeFee' | translate : 'One time delay fee' }}</mat-label>
          <input matInput type="text"  [(ngModel)]="pricelist.OneTimeExcessFee" (keypress)="numberOnly($event)"/>
          <mat-icon matSuffix matTooltip="{{ 'T4.Settings.Pricelist.tipOneTimeExcessFee' | translate : 'A one time fee when delay kicks in' }}">help</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'T4.Settings.Pricelist.txtPerHour' | translate : 'Delay fee per hour' }}</mat-label>
          <input matInput type="text" [(ngModel)]="pricelist.ExcessPerHour" (keypress)="numberOnly($event)" />
          <mat-icon matSuffix matTooltip="{{ 'T4.Settings.Pricelist.tipPerHour' | translate : 'A fee per hour delay' }}">help</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'T4.Settings.Pricelist.txtPerDay' | translate : 'Delay fee per day' }}</mat-label>
          <input matInput type="text" [(ngModel)]="pricelist.ExcessPerDay" (keypress)="numberOnly($event)" />
          <mat-icon matSuffix matTooltip="{{ 'T4.Settings.Pricelist.tipPerDay' | translate : 'A fee per day of delay. If used together with per hour fee, this will be a maximum daily fee.' }}">help</mat-icon>
        </mat-form-field>
      </div>
    </mat-tab>
  </mat-tab-group>
</t4-container>
<t4-container title="{{ 'T4.Settings.Pricelist.lblPeriods' | translate : 'Intervals' }}" *ngIf="pricelist.Type != 1">
  <t4-data-table #tblIntervals [rawData]="pricelist.Intervals" headline="" matSort (addClicked)="addInterval()" [allowPaging]="false" [allowFilter]="false" [allowAdd]="true" [autoGenerateColumns]="false">
    <ng-container matColumnDef="Id">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
        <button mat-icon-button (click)="deleteInterval(row)">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Interval">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.Pricelist.colInterval' | translate : 'Interval' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">
        <mat-form-field style="width: 75px; text-align: center;">
          <input matInput type="text" [(ngModel)]="row.Interval" (keypress)="numberOnly($event)" />
        </mat-form-field>
        <span> {{ 'T4.Settings.Pricelist.valHours' | translate : 'hours' }}</span></mat-cell>
    </ng-container>
    <ng-container matColumnDef="IsBaseInterval">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.Pricelist.colMinimum' | translate : 'Minimum interval' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;"><mat-radio-button name="minInterval" [checked]="row.IsBaseInterval" (change)="setBaseInterval(row)"></mat-radio-button></mat-cell>
    </ng-container>
  </t4-data-table>
</t4-container>
<t4-container title="{{ 'T4.Settings.Pricelist.lblPrices' | translate : 'Prices' }}">
  <ng-container toolbar>
   <!-- <button mat-button ><mat-icon>publish</mat-icon> Import</button>-->
    <button mat-button (click)="exportPricelist()" ><mat-icon>download</mat-icon> Export</button>
  </ng-container>
  <t4-data-table #tblPrices [rawData]="objectTypes" headline="" matSort [allowPaging]="false" [allowFilter]="false" [allowAdd]="false" [autoGenerateColumns]="false" [allowExcel]="true">
    <ng-container matColumnDef="ObjectType" [sticky]="true">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.Pricelist.colObjectType' | translate : 'Object type' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">
        <ng-container *ngIf="row.Title.indexOf('Turbo.') >= 0">{{ row.Title | translate }}</ng-container>
        <ng-container *ngIf="row.Title.indexOf('Turbo.') < 0">{{ row.Title }}</ng-container>
      </mat-cell>
    </ng-container>
    <ng-container [matColumnDef]="'Interval' + col.Id" *ngFor="let col of pricelist.Intervals">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">
        <ng-container *ngIf="pricelist.Type != 1">{{col.Interval}} {{ 'T4.Settings.Pricelist.valHours' | translate : 'hours' }}</ng-container>
        <ng-container *ngIf="pricelist.Type == 1">{{ 'T4.Settings.Pricelist.valPrice' | translate : 'Price' }}</ng-container>
      </mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">
        <mat-form-field style="width: 75px; text-align: center;">
          <input matInput type="text" (keypress)="numberOnly($event)" [value]="GetPrice(row.Id, col.Id)" (change)="SetPrice(row.Id, col.Id,$event.target.value)" />
        </mat-form-field>
      </mat-cell>
    </ng-container>
  </t4-data-table>
</t4-container>
